import { createStore } from 'vuex';
import {globalModule} from "./modules/_global";

// Create the main store, starting with only the global module
export const vueStore = createStore({
    modules: {
        global: globalModule,
    },
});
